import React, { useState } from "react";
import MyMap from "../../Maps/MyMap";
import MapOverviewIcon from "../../../assets/icons/monitoring/map_view-01.svg2";
import Clusters from "../../Maps/Clusters";
import { AbsoluteLoadingIndicator } from "../FullScreenLoadingIndicator";
import HelpButton from "../../HelpContent/HelpButton";

const filters = {
  Contacts: true,
  Assets: true,
  Direct: false,
  Indirect: false,
  ExcludeWithLocation: false,
};

export default function MapOverviewWidget() {
  const [loading, setLoading] = useState(false);

  return (
    <div className="h-100 p-3 rounded-3">
      <AbsoluteLoadingIndicator loading={loading} />

      <div className="card-body d-flex flex-column justify-content-between h-100">
        <div className="text-white ">
          <MapOverviewIcon width={20} className="me-2 white opacity-50" />
          <span className="small fw-bold widget-header"> MAP OVERVIEW</span>
          <HelpButton helpKey="widget-map-overview" iconClassName="white" />
        </div>
        <hr className="text-white my-2" />
        <MyMap mapTypeControl={false}>
          <Clusters filters={filters} setLoading={setLoading} />
        </MyMap>
      </div>
    </div>
  );
}
